const utils = {
  combinationUrlParam: function (params) {
    return Object.keys(params).map(function (key) {
      return encodeURIComponent(key) + "=" + encodeURIComponent(params[key]);
    }).join("&");
  },
  getUrlParam: function () {
    let url = document.location.toString();
    let arrObj = url.split("?");
    let params = Object.create(null);
    if (arrObj.length > 1) {
      arrObj = arrObj[1].split("&");
      arrObj.forEach(item => {
        item = item.split("=");
        params[item[0]] = item[1]
      })
    }
    return params;
  },
  getParam: function (name, url) {
    if (typeof name !== 'string') return false;
    if (!url) url = window.location.href;
    // 当遇到name[xx]时，对方括号做一下转义为 name\[xxx\]，因为下面还需要使用name做正则
    // eslint-disable-next-line
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    var results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  },
  /**
   * @method checkOperaSys
   * @returns {string}
   * @desc 判断当前客户端系统类型(ipad按pc适配)
   */
  checkOperaSys: function () {
    if (/(iPhone|iPod|iOS)/i.test(navigator.userAgent)) {
      return 'ios'
    } else if (/(Android)/i.test(navigator.userAgent)) {
      return 'android'
    } else if (/(iPad)/i.test(navigator.userAgent)) {
      return 'iPad'
    }
    return 'pc'
  },
  /**
   * @method checkRealOperaSys
   * @returns {string}
   * @desc 判断当前客户端系统类型,区分ipad
   */
  checkRealOperaSys: function () {
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      return 'ios'
    } else if (/(Android)/i.test(navigator.userAgent)) {
      return 'android'
    }
    return 'pc'
  },
  /**
   * @desc 通过UA判断页面所在的app
   *
   * */
  app: (function () {
    var _appReg = [/MicroMessenger/i, /gc-app/i, /mizhiBo/i, /weibo/i, /NewsArticle/i, /Bili/i, /tieba/i]
    var _ua = navigator.userAgent.toLowerCase()
    return {
      /* 判断是否是在微信app下 */
      isWeixin: function isWeixin() {
        return _appReg[0].test(_ua)
      },
      /* 判断是否是在小米游戏app下 */
      isMiGC: function isMiGC() {
        return _appReg[1].test(_ua)
      },
      /** * 判断是否是在直播app下 ***/
      isZhiBo: function isZhiBo() {
        return _appReg[2].test(_ua)
      },
      /** * 判断是否是在微博app下 ***/
      isWeiBo: function isWeiBo() {
        return _appReg[3].test(_ua)
      },
      /** * 判断是否是在头条app下 ***/
      isTouTiao: function isTouTiao() {
        return _appReg[4].test(_ua)
      },
      /** * 判断是否是在哔哩哔哩app下 ***/
      isBili: function isBili() {
        return _appReg[5].test(_ua)
      },
      /** * 判断是否是在百度贴吧app下 ***/
      isTieBa: function isTieBa() {
        return _appReg[6].test(_ua)
      },
      /** * 获取app平台 */
      which: function which() {
        if (this.isWeixin()) {
          return 'weixin'
        }
        if (this.isMiGC()) {
          return 'migc'
        }
        if (this.isZhiBo()) {
          return 'zhibo'
        }
        if (this.isWeiBo()) {
          return 'weibo'
        }
        if (this.isTouTiao()) {
          return 'toutiao'
        }
        if (this.isBili()) {
          return 'bilibili'
        }
        if (this.isTieBa()) {
          return 'tieba'
        }
        return 'none'
      }
    }
  })()
}
export default utils
